import { Box, Tooltip, Typography } from '@mui/material'
import { Help } from '@mui/icons-material'
import { FunctionToggle } from './FunctionToggle'
import { descriptionForPermission } from '../../../../utils/permissions'
import { type AuthorizedFunctionRow } from './authorizedFunctionRows'
import { styles } from './OrganizationCard.styles'

interface Props {
  rows: AuthorizedFunctionRow[]
  disabled: boolean
  onChange?: (functionName: string, checked: boolean) => void
}

export const AuthorizedFunctionSwitches = (props: Props): JSX.Element => {
  if (props.rows.length === 0) {
    return <Typography variant='body1' data-testid='noAuthorizedFunctions'>No authorized functions</Typography>
  }

  const handleChange = (functionName: string) => (_e: React.ChangeEvent<HTMLInputElement>, checked: boolean): void => {
    props.onChange?.(functionName, checked)
  }

  return <Box sx={props.disabled ? styles.functionGridReadOnly : styles.functionGrid} data-testid='authorizedFunctions'>
    <Typography variant='body1' sx={styles.functionHeader}>View</Typography>
    <Typography variant='body1' sx={styles.functionHeader}>Edit</Typography>
    <span />

    {props.rows.map((row) => {
      const description = descriptionForPermission(row.name)

      return <Box key={row.viewName !== '' ? row.viewName : row.editName} sx={{ display: 'contents' }} data-testid={`functionRow-${row.name}`}>
        {row.offersView
          ? <FunctionToggle
              name={row.viewName}
              checked={row.hasView}
              disabled={props.disabled || row.viewLocked}
              lockedByRole={!props.disabled && row.viewLocked}
              onChange={handleChange(row.viewName)}
              dataTestId={`${row.name}-View`}
          />
          : <span />}

        {row.offersEdit
          ? <FunctionToggle
              name={row.editName}
              checked={row.hasEdit}
              disabled={props.disabled || row.editLocked}
              lockedByRole={!props.disabled && row.editLocked}
              onChange={handleChange(row.editName)}
              dataTestId={`${row.name}-Edit`}
          />
          : <span />}

        <Box sx={{ ...styles.functionLabel, pl: `${row.depth * 16}px` }}>
          <Typography variant='body1'>{row.name}</Typography>

          {description !== '' && <Tooltip title={description}>
            <Help sx={styles.helpIcon} data-testid={`${row.name}-Help`} />
          </Tooltip>}
        </Box>
      </Box>
    })}
  </Box>
}
